export default "__VITE_ASSET__c80541f0__"